import styles from "./NavTopBarHeaderStart.module.scss"
import { NavTopBarHeaderStartProps } from "./NavTopBarHeaderStart.types"

export default function NavTopBarHeaderStart(props: NavTopBarHeaderStartProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
